var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormLabelIntagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25169 0H3.74829C1.95715 0 0.5 1.45715 0.5 3.24829V8.75178C0.5 10.5428 1.95715 12 3.74829 12H9.25178C11.0428 12 12.5 10.5428 12.5 8.75178V3.24829C12.5 1.45715 11.0428 0 9.25169 0ZM11.7965 8.75178C11.7965 10.1549 10.6549 11.2965 9.25169 11.2965H3.74829C2.34507 11.2965 1.2035 10.1549 1.2035 8.75178V3.24829C1.2035 1.84507 2.34507 0.703499 3.74829 0.703499H9.25178C10.6549 0.703499 11.7965 1.84507 11.7965 3.24829V8.75178Z",
    fill: "#A2A9AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49991 2.71882C4.69065 2.71882 3.21875 4.19069 3.21875 5.99997C3.21875 7.80925 4.69063 9.28113 6.49991 9.28113C8.30919 9.28113 9.78106 7.80925 9.78106 5.99997C9.78106 4.19069 8.30919 2.71882 6.49991 2.71882ZM6.49991 8.57763C5.07866 8.57763 3.92225 7.42134 3.92225 5.99997C3.92225 4.57872 5.07866 3.42232 6.49991 3.42232C7.92127 3.42232 9.07756 4.57872 9.07756 5.99997C9.07756 7.42134 7.92127 8.57763 6.49991 8.57763ZM9.85953 1.55353C9.32485 1.55353 8.88999 1.9885 8.88999 2.52307C8.88999 3.05775 9.32485 3.4927 9.85953 3.4927C10.3942 3.4927 10.8291 3.05775 10.8291 2.52309C10.8291 1.98843 10.3942 1.55353 9.85953 1.55353ZM9.85953 2.78913C9.71286 2.78913 9.59347 2.66974 9.59347 2.52307C9.59347 2.37632 9.71286 2.25703 9.85953 2.25703C10.0063 2.25703 10.1257 2.37632 10.1257 2.52307C10.1257 2.66974 10.0063 2.78913 9.85953 2.78913Z",
    fill: "#A2A9AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormLabelIntagram);
export default __webpack_public_path__ + "static/media/form-label-intagram.3eba7e0a140d3586be32358e7511fd29.svg";
export { ForwardRef as ReactComponent };